import React from 'react';
import AddCustomFields from '../../WindowSidebar/AddCustomFields';

// The BoardMenu "Custom Fields" screen mounts the popover content inline.
// Props plumbed down to AddCustomFields:
// - `embedded`         — drop the popover's own header chrome
// - `setActiveLabel`   — drive the BoardMenu's header title as the user
//                        drills into a field
// - `setBackHandler`   — register an interceptor for the BoardMenu's back
//                        button so it walks our internal nav (edit → list)
//                        before unwinding the menu's screen stack
const CustomFields = ({ boardId, setActiveLabel, setBackHandler }) => (
    <div className="screen custom-fields-screen">
        <AddCustomFields
            boardId={boardId}
            embedded
            setActiveLabel={setActiveLabel}
            setBackHandler={setBackHandler}
        />
    </div>
);

export default CustomFields;
